const FUEL_TYPES = {
  GAS: {display: 'Gas', value: 'Gas', showOrder: 0, def: false},
  HEAT_PUMP: {display: 'Heat Pump', value: 'Heat Pump', showOrder: 1, def: false},
  OTHER: {display: 'Other', value: 'Other', showOrder: 2, def: false},
};

export {FUEL_TYPES};